@if (user) {
  @if ("(min-width: 600px)" | mediaMatch | async) {
    <div
      class="toolbar"
      [class.toolbar-hover]="menuHover"
      (mouseenter)="onMenuEnter()"
      (mouseleave)="onMenuLeave()"
    >
      <div class="toolbar-container">
        <div class="toolbar-logo">
          @let logoSmallUrl =
            (tenantInfo$ | async)?.logoSmall
              | assetUrl: AssetFileSize.size100
              | async;
          @let logoUrl =
            (tenantInfo$ | async)?.logo
              | assetUrl: AssetFileSize.size300
              | async;
          <img
            class="toolbar-logo-image"
            [src]="
              menuHover
                ? logoUrl
                : logoSmallUrl || 'assets/verify-logo-small.png'
            "
            routerLink="/"
          />
        </div>
        <div class="toolbar-top">
          <button
            mat-icon-button
            class="toolbar-button"
            (click)="onToggleSearch()"
          >
            <mat-icon>search</mat-icon>
            <span class="toolbar-button-label">{{
              "search.search" | translate
            }}</span>
          </button>
          @if (
            (TenantFeature.consentManager | hasFeature) &&
            ([
              UserRule.projectAdmin,
              UserRule.projectEditing,
              UserRule.projectManagement,
              UserRule.projectDownloading,
              UserRule.projectUploading,
            ] | hasRule: "or")
          ) {
            <button
              mat-icon-button
              class="toolbar-button"
              routerLink="/projects"
            >
              <mat-icon>team_dashboard</mat-icon>
              <span class="toolbar-button-label">{{
                "project.projects" | translate
              }}</span>
            </button>
          }
          @if (
            (TenantFeature.dam | hasFeature) &&
            (UserRule.assetViewing | hasRule)
          ) {
            <button
              mat-icon-button
              class="toolbar-button"
              routerLink="/collections"
            >
              <mat-icon>gallery_thumbnail</mat-icon>
              <span class="toolbar-button-label">{{
                "collection.collections" | translate
              }}</span>
            </button>
          }
          @if (
            (TenantFeature.dam | hasFeature) &&
            (UserRule.assetViewing | hasRule)
          ) {
            <button mat-icon-button class="toolbar-button" routerLink="/assets">
              <mat-icon>image_search</mat-icon>
              <span class="toolbar-button-label">{{
                "asset.assets" | translate
              }}</span>
            </button>
          }
          @if (
            (TenantFeature.guides | hasFeature) &&
            (UserRule.guideViewing | hasRule)
          ) {
            <button mat-icon-button class="toolbar-button" routerLink="/guides">
              <mat-icon>article</mat-icon>
              <span class="toolbar-button-label">{{
                "guide.guides" | translate
              }}</span>
            </button>
          }
          <button
            class="toolbar-button"
            mat-icon-button
            (click)="onToggleNotifications(); notificationsSidenav.toggle()"
          >
            <mat-icon
              [matBadge]="notificationCount$ | async"
              [matBadgeHidden]="(notificationCount$ | async) < 1"
              >notifications</mat-icon
            >
            <span class="toolbar-button-label">{{
              "notification.notifications" | translate
            }}</span>
          </button>
        </div>

        <div class="toolbar-bottom">
          @if (UserRule.userManagement | hasRule) {
            <button
              mat-icon-button
              class="toolbar-button"
              routerLink="/settings/user-management"
            >
              <mat-icon>settings</mat-icon>
              <span class="toolbar-button-label">{{
                "base.settings" | translate
              }}</span>
            </button>
          }
          <button
            mat-icon-button
            class="toolbar-button"
            routerLink="/settings/profile"
          >
            @let selfieUrl =
              user?.selfie | assetUrl: AssetFileSize.size100 | async;
            @if (selfieUrl) {
              <img class="toolbar-profile-imageicon" [src]="selfieUrl" />
            } @else {
              <div class="toolbar-profile-icon">
                {{ initials }}
              </div>
            }
            <span class="toolbar-button-label">{{ user | userName }}</span>
          </button>
        </div>
      </div>
    </div>
  } @else {
    <div class="toolbar-mobile">
      <div class="toolbar-mobile-left">
        @let logoUrl =
          (tenantInfo$ | async)?.logo | assetUrl: AssetFileSize.size300 | async;
        <img
          class="toolbar-mobile-logo"
          [src]="logoUrl || 'assets/logo-darkblue.png'"
          routerLink="/"
        />
      </div>
      <!-- <button
        mat-icon-button
        class="toolbar-top-search-icon"
        (click)="onToggleSearch()"
      >
        <mat-icon>{{ "close" }}</mat-icon>
      </button> -->

      <div class="toolbar-mobile-right">
        <button
          mat-icon-button
          class="toolbar-mobile-search-icon"
          (click)="onToggleSearch()"
        >
          <mat-icon>{{ "search" }}</mat-icon>
        </button>
        <button
          class="toolbar-mobile-button"
          mat-icon-button
          (click)="onToggleNotifications(); notificationsSidenav.toggle()"
        >
          <mat-icon
            [matBadge]="notificationCount$ | async"
            [matBadgeHidden]="(notificationCount$ | async) < 1"
            >notifications</mat-icon
          >
        </button>
        @if (UserRule.userManagement | hasRule) {
          <button
            mat-icon-button
            class="toolbar-mobile-button"
            routerLink="/settings/user-management"
          >
            <mat-icon>settings</mat-icon>
          </button>
        }
        <div class="toolbar-mobile-profile">
          @let selfieUrl =
            user?.selfie | assetUrl: AssetFileSize.size100 | async;
          @if (selfieUrl) {
            <img class="toolbar-mobile-profile-imageicon" [src]="selfieUrl" />
          } @else {
            <div class="toolbar-mobile-profile-icon">
              {{ initials }}
            </div>
          }
        </div>
      </div>
    </div>
  }

  <mat-sidenav-container class="sidenav-container" [hasBackdrop]="true">
    <mat-sidenav-content><router-outlet /></mat-sidenav-content>
    <mat-sidenav
      #notificationsSidenav
      position="end"
      [fixedInViewport]="true"
      [fixedBottomGap]="0"
      [opened]="notificationsOpen"
      class="sidenav"
    >
      <button
        mat-icon-button
        class="sidenav-close-button"
        (click)="onToggleNotifications()"
      >
        <mat-icon>close</mat-icon>
      </button>
      <ng-scrollbar
        visibility="hover"
        orientation="vertical"
        (reachedBottom)="onLoadNotifications()"
        [reachedBottomOffset]="100"
      >
        @if (notificationsOpen) {
          <div class="notifications">
            @for (notification of notifications; track notification.id) {
              <app-notification
                [notification]="notification"
                (closeNotification)="onToggleNotifications()"
              ></app-notification>
            }
            @if ((notifications$ | async)?.length < 1) {
              <p class="notifications-notfound text-body-2">
                {{ "notification.no-notifications" | translate }}
              </p>
            }
          </div>
        }
      </ng-scrollbar></mat-sidenav
    >
  </mat-sidenav-container>

  @if ((uploads$ | async)?.length > 0) {
    <div class="process-indicator">
      {{
        "base.uploading-files"
          | translate: { count: (uploads$ | async)?.length }
      }}<mat-spinner diameter="20"></mat-spinner>
    </div>
  }
  @if (exportingMatches()) {
    <div class="process-indicator">
      {{
        "fprint.exporting-matches"
          | translate: { count: (uploads$ | async)?.length }
      }}<mat-spinner diameter="20"></mat-spinner>
    </div>
  }
}
